(() => {
  const grid = document.querySelector('.native-collection-grid');
  if (!grid) return;

  const slot = grid.querySelector('[data-responsive-sort-slot]');
  const sortWrapper = grid.querySelector('.facets-vertical-sort');
  if (!slot || !sortWrapper) return;

  const homeParent = sortWrapper.parentNode;
  const homeNextSibling = sortWrapper.nextSibling;
  const media = window.matchMedia('(max-width: 749px)');

  function placeSort() {
    if (media.matches) {
      if (sortWrapper.parentNode !== slot) {
        slot.appendChild(sortWrapper);
      }
      return;
    }

    if (sortWrapper.parentNode !== homeParent) {
      homeParent.insertBefore(sortWrapper, homeNextSibling);
    }
  }

  placeSort();

  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', placeSort);
  } else {
    media.addListener(placeSort);
  }
})();
